export const validateEmail = (email) => {
    var reg = /^[_A-Za-z0-9\-\+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    if (reg.test(email)) {
        return true;
    }
    return false;
};

export const closekeyBoard = () => {
    document.activeElement.blur();
};

export const onBlurImport = ({
    event,
    usageDetails,
    reportUsageFormObj,
    dispatch,
    editUsageDetails,
    setReportUsageFormObj,
    validateAccountDetails,
    setAccountValue,
    removePricingDetails,
    removeShippingDetails,
    resetProgressBarStatus,
}) => {
    if (
        !event?.target?.value ||
        !(
            event?.target?.value === usageDetails?.accountFormattedName ||
            event?.target?.value === usageDetails?.originalAccountFormattedName
        )
    ) {
        const object = {
            accountId: usageDetails?.originalAccountId,
            accountName: usageDetails?.originalAccountName,
            accountFormattedName: usageDetails?.originalAccountFormattedName,
        };
        dispatch(
            editUsageDetails({
                ...object,
                isHCPOAccountNonTissue: usageDetails?.originalIsHCPOAccountNonTissue,
                isHCPOAccountTissue: usageDetails?.originalIsHCPOAccountTissue,
            })
        );
        setReportUsageFormObj((prevStateObj) => ({
            ...prevStateObj,
            ...object,
            isChangeAccount: true,
            updatedZLBAccount: object.accountId,
            isChangedFromDefaultAccount: false,
        }));
        validateAccountDetails(usageDetails?.originalAccountId);
        setAccountValue(usageDetails?.originalAccountFormattedName || '');
    }

    if (
        reportUsageFormObj.isChangedFromDefaultAccount ||
        (event?.target?.value &&
            !(
                event?.target?.value === usageDetails?.accountFormattedName ||
                event?.target?.value === usageDetails?.originalAccountFormattedName
            ))
    ) {
        removePricingDetails();
        removeShippingDetails();
        dispatch(resetProgressBarStatus());
    }

    if (
        event?.target?.value &&
        !(
            event?.target?.value === usageDetails?.accountFormattedName ||
            event?.target?.value === usageDetails?.originalAccountFormattedName
        )
    ) {
        removePricingDetails();
        removeShippingDetails();
        dispatch(resetProgressBarStatus());
    }
};